import "./OptionPageNavbar.css";
import { useContext } from "react";
import { Link } from "react-router-dom";

import BreadcrumbsNav from "@common-components/BreadcrumbsNav/BreadcrumbsNav";
import { AuthContext } from "@contexts/AuthContext";

const OptionPageNavbar = () => {
  const { currentUserRole } = useContext(AuthContext);

  return (
    <nav className="OptionPageNavbar__container">
      <Link to="/" className="OptionPageNavbar__logo--link">
        {currentUserRole === "SALES" ||
        currentUserRole?.startsWith("SALES_") ? (
          <img
            src={`${process.env.PUBLIC_URL}/logo/MattamyLogo.svg`}
            alt="Mattamay Homes Logo"
            className="OptionPageNavbar__logo--MattamyImg"
          />
        ) : currentUserRole ? (
          <img
            src={`${process.env.PUBLIC_URL}/logo/BIMstudioLogo.svg`}
            alt="BIMstudio Logo"
            className="OptionPageNavbar__logo--BIMstudioImg"
          />
        ) : (
          <div className="OptionPageNavbar__logo--placeholder"></div>
        )}
      </Link>

      <BreadcrumbsNav />
    </nav>
  );
};

export default OptionPageNavbar;
